import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { TranslocoService } from '@ngneat/transloco';

import { Listbox } from 'primeng/listbox';

import { DropDownList } from '@core/interfaces';

@Component({
  selector: 'z-modal-listbox',
  templateUrl: './modal-listbox.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalListboxComponent implements OnInit, OnDestroy {
  destroy$ = new Subject<boolean>();

  form: FormGroup;

  @Input() list: DropDownList;

  @Input() display: boolean;

  @Input() popupWindowIcon: string = 'fad fa-list';
  @Input() popupWindowTitle: string;
  @Input() popupFilter: boolean = true;

  @Input() displayLabelOnly: boolean = false;

  @Input() selectButtonLabel: string;
  @Input() selectButtonIcon: string = 'pi pi-check';
  @Input() selectButtonClass: string = 'p-button-primary';

  @Input() cancelButtonLabel: string;
  @Input() cancelButtonIcon: string;
  @Input() cancelButtonClass: string = 'p-button-secondary';

  @Input() scrollHeight: string = '400px';

  @Input() dialogStyleClass?: string = 'dialog-medium';

  @Input() style?: any = { minHeight: '32rem' };

  @Output() selectValue = new EventEmitter<string>();

  @ViewChild('listbox') listbox: Listbox;

  selectedValue$ = new Subject<any>();

  @Input() columnWidth1: number = 100;
  @Input() columnWidth2: number;
  @Input() columnWidth3: number = 100;
  @Input() columnWidth4: number = 100;
  @Input() columnWidth5: number = 100;

  @Input() displayColumn1: boolean = true;
  @Input() displayColumn2: boolean = true;
  @Input() displayColumn3: boolean = false;
  @Input() displayColumn4: boolean = false;
  @Input() displayColumn5: boolean = false;

  columnWidthClass1: string;
  columnWidthClass2: string;
  columnWidthClass3: string;
  columnWidthClass4: string;
  columnWidthClass5: string;

  translate = (key: string | string[], params?: Record<string, string>, lang?: string) =>
    this.translocoService.translate(key, params, lang);

  constructor(private translocoService: TranslocoService) {}

  ngOnInit() {
    this.translocoService
      .selectTranslation()
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.popupWindowTitle = this.popupWindowTitle ?? this.translate('core.components.modal_listbox.select_value');
        this.selectButtonLabel = this.selectButtonLabel ?? this.translate('core.components.modal_listbox.select');
        this.cancelButtonLabel = this.cancelButtonLabel ?? this.translate('core.components.modal_listbox.cancel');
      });

    this.form = new FormGroup({
      value: new FormControl(null),
    });

    this.selectedValue$.pipe(takeUntil(this.destroy$)).subscribe((data) => {
      this.form.get('value').setValue(data);
    });

    this.columnWidthClass1 = this.columnWidth1 ? `fixed-column-${this.columnWidth1}` : '';
    this.columnWidthClass2 = this.columnWidth2 ? `fixed-column-${this.columnWidth2}` : '';
    this.columnWidthClass3 = this.columnWidth3 ? `fixed-column-${this.columnWidth3}` : '';
    this.columnWidthClass4 = this.columnWidth4 ? `fixed-column-${this.columnWidth4}` : '';
    this.columnWidthClass5 = this.columnWidth5 ? `fixed-column-${this.columnWidth5}` : '';
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  select = () => {
    if (this.form.get('value').value) {
      this.selectedValue$.next(this.form.get('value').value);
      this.selectValue.emit(this.form.get('value').value);
      this.closePopupList();
    }
  };

  closePopupList = () => {
    this.display = false;

    if (this.list?.length > 0) {
      this.listbox.uncheckAll();
    }

    this.selectValue.emit();
  };
}
